import { Fragment } from "react";
function ServicesExtAttr(props) {

    const { settings, serviceInfo, register } = props;
    function onChangeExt(e)
    {
        serviceInfo[e.target.name] = e.target.value;
    }
    const extSettings = settings.filter(s => (s.SettingName.search("Services_ExtAttr") > -1 || s.SettingName.search("Services_ComboBoxExtAttr") > -1) && s.SettingName.search("_Title") > -1);
    return (
        <div className="row">
            {extSettings && Array.isArray(extSettings) && extSettings.map((item, i) => {
                return (
                    <Fragment key={"Fr" + i}>
                        {item.SettingName.search("Services_ExtAttr") > -1 &&
                            <div key={'Ext' + item} className="form-group col-md-3">
                                <label className="ellipsisLabel"> {item.SettingValue} </label>
                                <input className="form-control" name={item.SettingName.replace("Services_", "").replace("_Title", "")} ref={register({})} type="text" onChange={onChangeExt}
                                    defaultValue={serviceInfo && serviceInfo[item.SettingName.replace("Services_", "").replace("_Title", "")] ? serviceInfo[item.SettingName.replace("Services_", "").replace("_Title", "")] : ''} />
                            </div>
                        }
                        {item.SettingName.search("Services_ComboBoxExtAttr") > -1 &&
                            <div key={'cmbExt' + i} className="form-group col-md-3">
                                <label className="ellipsisLabel"> {item.SettingValue} </label>
                                <select className="form-control" ref={register({})} name={item.SettingName.replace("Services_", "").replace("_Title", "")} onChange={onChangeExt}
                                    defaultValue={serviceInfo && serviceInfo[item.SettingName.replace("Services_", "").replace("_Title", "")] ? serviceInfo[item.SettingName.replace("Services_", "").replace("_Title", "")] : ''}>
                                    <option value=''>انتخاب کنید</option>
                                    {settings.find(s => s.SettingName === item.SettingName.replace("_Title", "") + '_Items').SettingValue &&
                                        settings.find(s => s.SettingName === item.SettingName.replace("_Title", "") + '_Items').SettingValue.split("|").map((item, i) => { return (<option key={'item' + i} value={item}>{item}</option>) })
                                    }
                                </select>
                            </div>
                        }
                    </Fragment>)
            }
            )}
        </div>
    )
}
export default ServicesExtAttr;